import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logger from 'utils/logger';

export function useIManageBatchUpload(
  proceedToCreateBatch: (
    folderId: string,
    data: any[],
    rootFolderLink: string,
    templateId?: string,
  ) => Promise<void>,
) {
  const dispatch = useDispatch();
  const payload = useSelector((state: any) => state.case.iManageBatchPayload);
  const iManageFailedDocuments = useSelector((state: any) => state.case.iManageFailedDocuments ?? []);

  useEffect(() => {
    // If there are failures, the summary dialog handles the proceed action
    if (!payload || iManageFailedDocuments.length > 0) return;

    const run = async () => {
      try {
        const folderId = payload.FolderId ?? payload.folderId;
        const rootFolderLink = payload.RootFolderLink ?? payload.rootFolderLink ?? '';
        const data = (payload.Data ?? payload.data ?? []).map((f: any) => ({
          uniqueId: f.UniqueId ?? f.uniqueId,
          fileName: f.FileName ?? f.fileName,
          folderPath: f.FolderPath ?? f.folderPath,
          originalFileName: f.OriginalFileName ?? f.originalFileName,
          rootFolderLink: f.RootFolderLink ?? f.rootFolderLink,
        }));

        await proceedToCreateBatch(folderId, data, rootFolderLink);
      } catch (err) {
        Logger.ERROR('iManage batch upload failed', err);
      } finally {
        dispatch({ type: 'CASE_IMANAGE_BATCH_PAYLOAD_CLEAR' });
      }
    };

    run();
  }, [payload, iManageFailedDocuments, dispatch, proceedToCreateBatch]);
}
